import { Component, Input, OnInit } from '@angular/core';
import { Colors } from '../../helpers/colors';

@Component({
  selector: 'app-signature-status',
  templateUrl: './signature-status.component.html',
  styleUrls: ['./signature-status.component.scss']
})
export class SignatureStatusComponent {

  @Input() statusClient: boolean = false;
  @Input() statusClientEndorsement: boolean = false;
  @Input() isEndorsement: boolean = false;

  colors = Colors;

  constructor() { }
}
